import styled from 'styled-components';

export const Wrapper = styled.section`
  padding: 1rem;
  padding-bottom: 0;
`;

export const PostCardsList = styled.div`
  display: grid;
  justify-content: center;
  grid-template-columns: repeat(auto-fill, minmax(220px, 300px));
  grid-gap: 0.3rem;
  @media screen and (min-width: 992px) {
    justify-content: space-between;
    grid-template-columns: repeat(auto-fill, minmax(27.5%, 30%));
  }
  @media screen and (min-width: 1200px) {
    grid-template-columns: repeat(auto-fill, minmax(240px, 260px));
  }
`;
